import * as o from "react";
import a from "../lib/IconBase.es.js";
import i from "../defs/ArrowRight.es.js";
const r = o.forwardRef((t, e) => /* @__PURE__ */ o.createElement(a, { ref: e, ...t, weights: i }));
r.displayName = "ArrowRightIcon";
const s = r;
export {
  s as ArrowRight,
  r as ArrowRightIcon
};
